import script from "./PriceHealth.vue?vue&type=script&setup=true&lang=ts"
export * from "./PriceHealth.vue?vue&type=script&setup=true&lang=ts"

import "./PriceHealth.vue?vue&type=style&index=0&id=c386bc74&lang=scss"

const __exports__ = script;

export default __exports__